// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__kIwd6","notes":"Notes_notes__fekMp","note":"Notes_note__3FauR","markdown":"Notes_markdown__1ftxl"};